<template>
  <textarea
    v-if="item.operation.return.id"
    rows="2"
    class="bg-white border border-dashed border-gray-300 hover:border-blue-500 h-full p-0.5 text-xs tracking-tighter leading-3"
    v-model.lazy="item.operation.return.instructions"
    @change="
      $emit(
        'columnEvent',
        'autoSave',
        { type: 'Operation', ...item.operation.return },
        'instructions',
        $event.target.value,
      )
    "
  />
</template>

<script>
export default {
  name: "order-status-return-instructions",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
